import { Button, Select, useDisclosure, useToast } from "@chakra-ui/react";
import React from "react";
import { updatePodcastPosition, updateSeriesPosition } from "../../utils/api";
import CreateModal from "../common/Modal/Modal";
import CreateInput from "../common/TextInputs/Input";

const Position = ({ item, setLoading, reload }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const [newPosition, setNewPosition] = React.useState({});
  const changePosition = async () => {
    setLoading(true);
    const selectedId = newPosition.movieId || newPosition.seriesId;
    const selectedContent = item.content?.find(
      (contentItem) => contentItem.item._id === selectedId
    );
    const isMovie = selectedContent?.kind === "movie";
    const data = {
      ...newPosition,
      categoryId: item._id,
    };
    const [success] = isMovie
      ? await updatePodcastPosition(data)
      : await updateSeriesPosition(data);
    toast({
      title: "Position Changed",
      description: success
        ? "Position Changed Successfully"
        : "Failed to change position",
      status: success ? "success" : "error",
      duration: 9000,
      isClosable: true,
    });
    setLoading(false);
    reload();
  };
  return (
    <>
      <Button variant={"solid"} colorScheme={"blue"} onClick={onOpen}>
        Change Position
      </Button>
      <CreateModal
        isOpen={isOpen}
        onClose={onClose}
        title={"Change Position"}
        create={changePosition}
      >
        <Select
          placeholder={"Select Position"}
          onChange={(e) => {
            const selectedContent = item.content.find(
              (contentItem) => contentItem.item._id === e.target.value
            );
            const isMovie = selectedContent?.kind === "movie";
            setNewPosition((prev) => ({
              ...prev,
              movieId: isMovie ? e.target.value : undefined,
              seriesId: isMovie ? undefined : e.target.value,
              position:
                item.content.findIndex(
                  (contentItem) => contentItem.item._id === e.target.value
                ) + 1,
            }));
          }}
        >
          {item?.content?.map((item, index) => {
            return (
              <option key={index} value={item?.item?._id}>
                {item?.item?.name}
              </option>
            );
          })}
        </Select>
        <CreateInput
          name={`Position (${item?.content?.length})`}
          type={"number"}
          onChange={(e) =>
            setNewPosition((prev) => ({ ...prev, position: e.target.value }))
          }
          value={newPosition.position}
        />
      </CreateModal>
    </>
  );
};

export default Position;